import React from "react";
import PropTypes from "prop-types";

const ShowStatsSection = ({
  canShowStats,
  showStats,
  onToggleStats,
  showLabel = "Show statistics",
  hideLabel = "Hide statistics",
  panelClassName = "mt-6 w-full bg-white shadow-md rounded-lg p-6",
  children = null,
}) => {
  return (
    <div className="w-full">
      {canShowStats && (
        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={onToggleStats}
            className="px-6 h-14 bg-[#ff0000] text-white rounded-xl text-lg font-bold"
            aria-label={showStats ? "Hide statistics panel" : "Show statistics panel"}
          >
            {showStats ? hideLabel : showLabel}
          </button>
        </div>
      )}

      {showStats && canShowStats && <div className={panelClassName}>{children}</div>}
    </div>
  );
};

ShowStatsSection.propTypes = {
  canShowStats: PropTypes.bool.isRequired,
  showStats: PropTypes.bool.isRequired,
  onToggleStats: PropTypes.func.isRequired,
  showLabel: PropTypes.string,
  hideLabel: PropTypes.string,
  panelClassName: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(ShowStatsSection);
